import qs from 'qs';
import {STATUS} from '@jobseeker/common-core/constants';
import axiosInterceptorInstance from '@jobseeker/common-core/helpers/axiosInterceptor';

const axios = axiosInterceptorInstance(
  `${process.env.NEXT_PUBLIC_API_GATEWAY_GLADIATOR}/ext/${process.env.NEXT_PUBLIC_PREFIX_USER_SERVICE}/`
);

const getRecommendationById = async (options: object) => {
  try {
    const response = await axios.get(`/recommendation`, options);
    if (response[STATUS] === 200) {
      return response.data;
    }
    return {};
  } catch (error: any) {
    return {
      error: {
        message: error.response.data.error.message,
        code: error.response.data.error.statusCode,
      },
    };
  }
};

const addComment = async (
  recommendationId: number,
  recommendationText: string,
  email: string,
  socialId: number,
  senderName: string,
  userEmail: string,
  options: object
) => {
  try {
    const response = await axios.post(
      `/recommendation/addcomment`,
      qs.stringify({
        recommendationId,
        recommendationText,
        email,
        socialId,
        senderName,
        userEmail,
      }),
      options
    );
    if (response[STATUS] === 200) {
      return response.data;
    }
    return {data: {}};
  } catch (error: any) {
    return {
      error: {
        message: error.response?.data?.error?.message || 'Unknown error',
        code: error.response?.data?.error?.statusCode || 500,
      },
    };
  }
};

const getIdByEmail = async (email: string, options: object) => {
  try {
    const response = await axios.get('/recommendation/socialuserid', {
      params: {
        email,
      },
      ...options,
    });
    if (response[STATUS] === 200) {
      return response.data;
    }
    return {};
  } catch (error: any) {
    return {
      error: {
        message: error.response.data.error.message,
        code: error.response.data.error.statusCode,
      },
    };
  }
};

const getSocialInfo = async ({
  userId,
  loginVia,
  userType,
  email,
  options,
}: {
  userId?: number;
  loginVia?: number;
  userType?: number;
  email?: string;
  options: object;
}) => {
  try {
    const response = await axios.get(`/socialinfo`, {
      params: {
        userId,
        loginVia,
        userType,
        email,
      },
      ...options,
    });
    if (response[STATUS] === 200) {
      return response.data;
    }
    return {};
  } catch (error: any) {
    return {
      error: {
        message: error.response.data.error.message,
        code: error.response.data.error.statusCode,
      },
    };
  }
};

const getProfileById = async (userId: number, options: object) => {
  try {
    const response = await axios.get(`/recommendation/profile`, {
      params: {
        userId,
      },
      ...options,
    });
    if (response[STATUS] === 200) {
      return response.data;
    }
    return {};
  } catch (error: any) {
    return {
      error: {
        message: error.response.data.error.message,
        code: error.response.data.error.statusCode,
      },
    };
  }
};

const getRecruiterIdByEmail = async (email: string, options: object) => {
  try {
    const response = await axios.get('/recommendation/recruiterid', {
      params: {
        email,
      },
      ...options,
    });
    if (response[STATUS] === 200) {
      return response.data;
    }
    return {};
  } catch (error: any) {
    return {
      error: {
        message: error.response.data.error.message,
        code: error.response.data.error.statusCode,
      },
    };
  }
};

const addSocialInfo = async (
  userId: number,
  type: number,
  name: string,
  publicId: string,
  positions: string,
  loginVia: number,
  status: number,
  requestedEmail: string,
  picUrl: string,
  options: object
) => {
  try {
    const response = await axios.post(
      `/socialinfo/addsocialuser`,
      qs.stringify({
        userId,
        type,
        name,
        publicId,
        positions,
        loginVia,
        status,
        requestedEmail,
        picUrl,
      }),
      options
    );
    if (response[STATUS] === 200) {
      return response.data.socialId;
    }
    return {data: {}};
  } catch (error: any) {
    return {
      error: {
        message: error.response?.data?.error?.message || 'Unknown error',
        code: error.response?.data?.error?.statusCode || 500,
      },
    };
  }
};

const ext = {
  getRecommendationById,
  addComment,
  getIdByEmail,
  getSocialInfo,
  getProfileById,
  getRecruiterIdByEmail,
  addSocialInfo,
};

export default ext;
